import React from "react";
import { Image, Text, View } from "react-native";
import { getImageUri } from "../assets/Images";
import { getTranslatedProperty } from "../services/i18n";
import commonStyles from "../styles/commonStyles";

const LiveWeatherElement = props => {
  let {
    font,
    fontLight,
    fontBold,
    p5,
    row,
    color4,
    flex1,
    flex2,
    fs10,
    fs20,
    wrap,
    alignItemsCenter,
    justifyContentCenter,
    textCenter,
    pr5,
    color5
  } = commonStyles;
  let { hour, data, customProps } = props;

  return (
    <View style={[row, ...customProps, p5, flex1]}>
      <View style={[pr5, flex1]}>
        <Text style={[font, color4]}>
          {hour}
          h00
        </Text>
        <Text style={[fontBold, fs20]}>{data[hour].temp} °</Text>
        <Text style={[fontLight, fs10, color5]}>
          💦 {data[hour].humidity} %
        </Text>
      </View>
      <View style={[alignItemsCenter, justifyContentCenter, flex2]}>
        <View style={(flex1, { height: 80 })}>
          <Image
            style={[{ width: 70, height: 70 }]}
            source={getImageUri(data[hour].icon)}
          />
        </View>
        <Text
          style={[font, wrap, { fontSize: 11 }, textCenter]}
          numberOfLines={2}
        >
          {getTranslatedProperty(data[hour], "description")}
        </Text>
      </View>
    </View>
  );
};

export default LiveWeatherElement;
